import { forwardRef, Ref } from 'react';
import { AllieInputProps } from '../Input/Input.types';
import { StyledInput, StyledItem, StyledSpan } from '../Input/Input.styles';
import { AllieNote } from '../../Item/Note';
import { AllieCloseCircleIcon } from '../../../styling/icons';
import { AllieText } from '../../Text';
import React from 'react';
import { IonButton } from '@ionic/react';
import { AllieButton } from '../../Buttons/Button';

export const AllieInputMobileApp = forwardRef(
  (
    {
      allieType = 'primary',
      corner = 'rounded',
      allieSize = 'normal',
      disabled = false,
      shadow = false,
      onChange,
      children,
      errorMessage,
      icon,
      suffix,
      onClick,
      ...props
    }: AllieInputProps,
    ref
  ) => {
    return (
      <>
        <StyledItem
          allieType={allieType}
          corner={corner}
          allieSize={allieSize}
          disabled={disabled}
          shadow={shadow}
          className={`${suffix ? 'input-with-suffix' : ''}`}
        >
          <StyledInput
            onIonChange={onChange}
            allieType={allieType}
            corner={corner}
            allieSize={allieSize}
            disabled={disabled}
            shadow={shadow}
            ref={ref as Ref<HTMLIonInputElement>}
            {...props}
          />
          {icon && (
            <AllieButton
              allieType="text"
              allieSize="none"
              style={{
                height: '20px',
                paddingRight: '16px',
                cursor: 'pointer',
                alignSelf: 'center',
              }}
              onclick={(e: any) => {
                e.stopPropagation();
                onClick?.();
              }}
            >
              {icon}
            </AllieButton>
          )}
          {suffix && (
            <StyledSpan>
              {typeof suffix === 'string' ? (
                <AllieText type="body1" weight={500} color="neutral-50">
                  {suffix}
                </AllieText>
              ) : (
                React.isValidElement(suffix) && suffix
              )}
            </StyledSpan>
          )}
        </StyledItem>
        {errorMessage && (
          <AllieNote className="allie-text-field3" slot="error">
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                columnGap: '10px',
              }}
            >
              <AllieCloseCircleIcon color="error" />
              {errorMessage}
            </div>
          </AllieNote>
        )}
      </>
    );
  }
);
